import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
export const HeroSection = () => {
  const navigate = useNavigate();
  const scrollToProducts = () => {
    const productsSection = document.getElementById("products-section");
    if (productsSection) {
      productsSection.scrollIntoView({
        behavior: "smooth"
      });
    } else {
      // Fallback to navigation if section not found
      navigate("/signup");
    }
  };
  return <div className="bg-[#EFFFF6] text-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-[30px] lg:px-[30px] border-b">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">Solusi EduTech Terbaik untuk Lembaga Pendidikan Modern</h1>
            <p className="text-lg mb-8">Kelola Lembaga Pendidikan Anda dengan lebih efisien menggunakan platform digital yang terintegrasi dan mudah digunakan.</p>
            <Button className="bg-[#008169] text-white hover:bg-[#006a55] px-8 py-3 rounded-full text-lg font-semibold" onClick={scrollToProducts}>
              Mulai Sekarang
            </Button>
          </div>
          <div className="hidden md:block">
            <img src="https://www.infradigital.io/img/artwork_about.svg" alt="Modern Education" className="w-full" onError={e => {
            const target = e.target as HTMLImageElement;
            target.src = "https://img.freepik.com/free-vector/digital-education-illustration_24908-57909.jpg";
          }} />
          </div>
        </div>
      </div>
    </div>;
};